<template>
  <div
    class="person"
    :itemscope="hasItemscope ? 'itemscope' : false"
    :itemtype="hasItemscope ? 'https://schema.org/Person' : false"
  >
    <div class="person__header">
      <div
        v-for="item in renderIf(showAgeLabel)"
        :key="item"
        class="person__age person__age--header"
      >
        <div
          v-for="item in renderIf(ageLabel)"
          :key="item"
          class="person__age-text"
          v-text="ageLabel"
        />
        <div
          v-for="item in renderIf(age)"
          :key="item"
          class="person__age-amount"
          v-text="age"
        />
      </div>
      <a
        v-for="item in renderIf(
          nameLink || name || location || dob || socialCount
        )"
        :key="item"
        :href="nameLink"
        :rel="nameRel"
        :target="nameTarget"
        class="person__header-text"
        @click="handleNameLink"
      >
        <component
          :is="personHeaderElement"
          class="person__header-title"
          :itemprop="hasItemscope ? 'name' : false"
          v-html="header"
        />
        <span
          v-for="item in renderIf(location)"
          :key="item"
          class="person__header-subtext"
          v-text="location"
        />
        <span
          v-for="item in renderIf(dob)"
          :key="item"
          class="person__header-subtext"
          v-text="formattedDob"
        />
        <span
          v-for="item in renderIf(socialCount && socialCount > 0)"
          :key="item"
          class="person__header-subtext"
          v-text="`Social: ${socialCount}`"
        />
      </a>
      <slot name="header" />
    </div>
    <div class="person__content">
      <slot></slot>
    </div>
  </div>
</template>

<script>
import helpers from '@/assets/js/shared/misc/helpers';

export default {
  name: 'wl-person',
  computed: {
    header() {
      if (this.headerSpanText) {
        return `${this.name}<span class="person__header-title person__header-title--span">${this.headerSpanText}</span>`;
      }
      return this.name;
    },
    formattedDob() {
      const date = new Date(this.dob);
      const year = date.getFullYear();
      const month = date.toLocaleString('default', { month: 'long' });
      return `${month} ${year}`;
    }
  },
  methods: {
    /**
     * If statement vue hack to prevent <!-- --> comment
     * @param condition
     * @returns {[]}
     */
    renderIf(condition) {
      return helpers.renderIf(condition);
    },
    handleNameLink(evt) {
      if (this.hasNameLinkHandler) {
        evt.preventDefault();
        evt.stopPropagation();
        this.$emit('handle-name-link', evt);
      }
    }
  },
  props: {
    // Name of the person (ex: Efrain Lugo)
    name: {
      type: String,
      required: false
    },
    // Text to go next to header name for separate styles
    headerSpanText: {
      type: String,
      required: false
    },
    // The location of the person (ex: Orlando, FL)
    location: {
      type: String,
      required: false
    },
    // Link that's used on the name of the person
    nameLink: {
      type: String,
      required: false
    },
    // Label used for the CTA
    ctaLabel: {
      type: String,
      required: false,
      default: 'View Details'
    },
    // The persons age (I made it a string or number since information uses 90+ and others 80+)
    age: {
      type: [String, Number],
      required: false,
      default: '-'
    },
    // Label used to display person's age
    ageLabel: {
      type: String,
      required: false,
      default: 'Age:'
    },
    // Where to show the schema information using itemscope instead of json
    hasItemscope: {
      type: Boolean,
      required: false,
      default: false
    },
    // Show label and age on the person's card
    showAgeLabel: {
      type: Boolean,
      default: true
    },
    // rel attribute for person__header-text
    nameRel: {
      type: String,
      required: false,
      default: 'nofollow'
    },
    // target attribute for person__header-text
    nameTarget: {
      type: String,
      required: false,
      default: '_self'
    },
    // if parent would like to override the name link click functionality this needs to be true, and the @handle-name-link event needs to be passed in
    hasNameLinkHandler: {
      type: Boolean,
      required: false,
      default: false
    },
    // Person Header Title Element
    personHeaderElement: {
      type: String,
      required: false,
      default: 'h2'
    },
    // Birth date of the person (ex: 1950-01-01)
    dob: {
      type: String,
      required: false
    },
    // Number of social media results for the person
    socialCount: {
      type: Number,
      required: false
    }
  }
};
</script>
